export const minimalJewels = ['Large Cluster Jewel', 'Medium Cluster Jewel', 'Small Cluster Jewel'];
export const minimalCharms = [];

export const rareOnlySpecialJewellery: string[] = [];

export const currencyTypesToHide = ['Tattoos', 'Scarabs', 'Essences', 'Runegrafts'];

export const currencyTypesNotDroppable: string[] = ["Omens", "Runegrafts", "Tattoos"];

export const ruthlessDisabledCurrencyItems = [
  'Stacked Deck', 'Enkindling Orb', 'Instilling Orb',
  'Orb of Binding',
  'Tailoring Orb', 'Tempering Orb',
  'Veiled Exalted Orb', 'Veiled Chaos Orb',
  'Orb of Dominance', "Awakener's Orb",
  "Shaper's Exalted Orb", "Elder's Exalted Orb",
  "Crusader's Exalted Orb", "Hunter's Exalted Orb",
  "Redeemer's Exalted Orb", "Warlord's Exalted Orb",
  // All specific delirium orb variants (replaced by generic "Delirium Orb")
  'Fine Delirium Orb', 'Singular Delirium Orb', "Thaumaturge's Delirium Orb",
  "Blacksmith's Delirium Orb", "Armoursmith's Delirium Orb", "Cartographer's Delirium Orb",
  "Jeweller's Delirium Orb",
  'Whispering Delirium Orb', 'Fragmented Delirium Orb',
  'Skittering Delirium Orb', 'Fossilised Delirium Orb', "Diviner's Delirium Orb",
  'Blighted Delirium Orb',
];

export const ruthlessDisabledCurrencyTypes = ['Divination Cards'];

export const ruthlessOnlyCurrencyItems = ['Delirium Orb'];

export const alwaysUseFixedValueCurrency = ['Scroll of Wisdom', 'Portal Scroll'];

export const defaultFavouriteBasicCurrencyTypes: string[] = [
  "Orb of Alteration", "Orb of Alchemy", "Vaal Orb", "Chaos Orb", "Divine Orb"];

export const cheapCurrency = [
  "Scroll of Wisdom", "Portal Scroll",
  "Transmutation Shard", "Alteration Shard", "Alchemy Shard", "Chaos Shard", "Regal Shard",
  "Orb of Transmutation", "Orb of Augmentation", "Orb of Chance",
  "Jeweller's Orb", "Chromatic Orb",
  "Instilling Orb", "Enkindling Orb",
  "Regal Orb", "Orb of Alteration", "Vaal Orb", "Orb of Alchemy",
  "Armourer's Scrap", "Blacksmith's Whetstone", "Glassblower's Bauble",
  "Clear Oil", "Sepia Oil", "Amber Oil", "Verdant Oil", "Teal Oil", "Azure Oil",
  "Lesser Eldritch Ember", "Lesser Eldritch Ichor", "Rogue's Marker",
];

export const stackableCurrency = [
  // All currency that can drop in stacks
  "Scroll of Wisdom", "Portal Scroll", "Orb of Augmentation", "Orb of Transmutation",
  "Orb of Binding", "Armourer's Scrap", "Orb of Chance", "Blacksmith's Whetstone",
  "Blessed Orb", "Chromatic Orb", "Instilling Orb", "Jeweller's Orb",
  "Lesser Eldritch Ember", "Lesser Eldritch Ichor", "Orb of Alchemy", "Orb of Alteration", "Orb of Fusing",
  "Orb of Regret",
  "Astragali", "Enkindling Orb", "Glassblower's Bauble", "Greater Eldritch Ichor",
  "Orb of Scouring", "Orb of Unmaking", "Regal Orb", "Scrap Metal",
  "Vaal Orb", "Burial Medallion", "Chaos Orb", "Exotic Coinage", "Exalted Orb",
  "Gemcutter's Prism", "Grand Eldritch Ichor", "Greater Eldritch Ember", "Stacked Deck",
  "Ancient Orb", "Grand Eldritch Ember", "Orb of Annulment", "Rogue's Marker",
  "Sacrifice at Dawn", "Sacrifice at Dusk", "Sacrifice at Midnight", "Sacrifice at Noon",

  // Shards
  "Regal Shard", "Chaos Shard", "Annulment Shard", "Exalted Shard", "Fracturing Shard",

  // Catalysts
  "Abrasive Catalyst", "Accelerating Catalyst", "Imbued Catalyst", "Intrinsic Catalyst", "Noxious Catalyst", "Turbulent Catalyst", "Unstable Catalyst",
  "Tempering Catalyst", "Fertile Catalyst", "Prismatic Catalyst",

  // Oils
  "Tainted Oil", "Reflective Oil", "Prismatic Oil", "Amber Oil", "Azure Oil", "Indigo Oil",
  "Violet Oil", "Crimson Oil", "Black Oil", "Opalescent Oil", "Silver Oil", "Golden Oil",
  "Verdant Oil", "Teal Oil", "Clear Oil", "Sepia Oil",

  // Splinters
  'Timeless Eternal Empire Splinter', 'Timeless Karui Splinter', 'Timeless Maraketh Splinter', 'Timeless Templar Splinter', 'Timeless Vaal Splinter',
  'Simulacrum Splinter',
  'Ritual Splinter',
];

export const itemColors = {
  normal: 'rgb(200,200,200)',
  magic: 'rgb(136,136,255)',
  rare: 'rgb(255,255,119)',
  unique: 'rgb(175,96,37)',
  currency: 'rgb(170,158,130)',
  gold: 'rgb(198, 171, 88)',
  divinationCard: 'rgb(27,162,155)',
};

export const restrictedDropTypesToTreatAsRegular = [
  "Farrul, First of the Plains",
  "Fenumus, First of the Night",
  "Saqawal, First of the Sky",
  "Blight",
  "Delirium Bosses",
  "Expedition",
  "Incursion",
  "Recipe",
];

export const nonDroppableUniqueBossTypes = [
  "Recipe",
];

export const cantHaveQualityItemClasses: string[] = [
  'Belts', 'Stackable Currency', 'Essences', 'Expedition Logbooks', 'Jewels', 'Abyss Jewels', 'Relics',
  'Divination Cards', 'Map Fragments', 'Misc Map Items', 'Blueprints', 'Contracts',
  'Delve Stackable Socketable Currency',
];

export const cantHaveSocketsItemClasses: string[] = [
  ...cantHaveQualityItemClasses,
  'Amulets', 'Rings', 'Belts', 'Life Flasks', 'Mana Flasks', 'Hybrid Flasks', 'Utility Flasks', 'Tinctures',
  'Skill Gems', 'Support Gems', 'Maps',
];

export const itemTypesWithTwoSockets: string[] = [];

export const maxDefaultSocketsPerItemType = {
};

export const excludedChanceBaseItemClasses: string[] = [];

export const hardCodedChanceBases: string[] = [
]
